// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: デモページ作成
const AdminOpsDemoCreateApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_demo_create";

    const ExecAdminOpsDemoCreateApi = async (pageName, title, reloadSec) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: { page_name: pageName, title: title, reload_sec: reloadSec } });
    };

    return ExecAdminOpsDemoCreateApi;
};

export default AdminOpsDemoCreateApi;
